export const SITE_ORIGIN = 'https://turbans.ai';

export const LEGAL_LINKS = {
  privacy: `${SITE_ORIGIN}/privacy`,
  terms: `${SITE_ORIGIN}/terms`,
  support: `${SITE_ORIGIN}/support`,
  deletion: `${SITE_ORIGIN}/delete-account`,
  subscriptions: `${SITE_ORIGIN}/subscription-terms`,
} as const;

export const LEGAL_PATHS = {
  privacy: '/privacy',
  terms: '/terms',
  support: '/support',
  deletion: '/delete-account',
  subscriptions: '/subscription-terms',
} as const;

export const OPERATOR_NAME = 'J sodhi';
export const OPERATOR_REGION = 'Australia';
export const CONTACT_EMAIL = 'info@turbans.ai';
export const EFFECTIVE_DATE = '26 August 2026';